import { makeStyles } from "@material-ui/core";
import type { AppContext } from "../hooks/useAppContext";

export const NAV_COLORS: Record<AppContext, string> = {
  default: "#242E21", // Devleaps green
  crmon: "#1e1244", // Deep indigo-purple
};

export const useRootStyles = makeStyles((theme) => ({
  appBar: {
    // Base color — overridden at component level via style prop for dynamic contexts
    backgroundColor: "#242E21",
    color: "#FFFFFF",
    transition: "background-color 0.3s ease",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  logo: {
    height: 50,
    marginRight: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    "& img": {
      height: "100%",
      width: "auto",
    },
  },
  navButtons: {
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  navButton: {
    textTransform: "none",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  iconButton: {
    color: "#FFFFFF",
  },
  hamburgerButton: {
    color: "#FFFFFF",
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "inline-flex",
    },
  },
  drawer: {
    width: 250,
  },
  drawerPaper: {
    width: 250,
    // Base color — overridden at component level via PaperProps style for dynamic contexts
    backgroundColor: "#242E21",
    color: "#FFFFFF",
    transition: "background-color 0.3s ease",
  },
  drawerList: {
    paddingTop: theme.spacing(2),
  },
  drawerItem: {
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
  },
  drawerIcon: {
    color: "#FFFFFF",
  },
  searchDialog: {
    "& .MuiDialog-paper": {
      width: "80%",
      maxWidth: "900px",
      height: "80vh",
      maxHeight: "800px",
    },
  },
  searchDialogContent: {
    padding: 0,
    position: "relative",
  },
  searchCloseButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    zIndex: 1,
  },
  // CRMon context styles
  crmonLogoWrapper: {
    height: 44,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(3),
  },
  crmonLogo: {
    height: "100%",
    width: "auto",
    objectFit: "contain" as const,
  },
  crmonDrawerHeader: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    padding: theme.spacing(3, 2, 2),
    borderBottom: "1px solid rgba(255,255,255,0.12)",
    marginBottom: theme.spacing(1),
    width: "100%",
  },
  crmonDrawerLogo: {
    height: 64,
    width: "auto",
    marginBottom: theme.spacing(1),
  },
  crmonDrawerTitle: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: 18,
    letterSpacing: 1,
  },
  backButton: {
    textTransform: "none" as const,
    color: "rgba(255,255,255,0.7)",
    fontSize: 12,
    padding: theme.spacing(0.5, 1),
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      color: "#FFFFFF",
    },
  },
}));
